import { FieldBase, IFieldOptions } from './field-base.interface'


export class TextboxField extends FieldBase<string> {
  controlType = 'textbox'
  type: string

  constructor(options: IFieldOptions<string> = {}) {
    super(options)
    this.type = options['type'] || ''
  }
}
